export default __webpack_public_path__ + "static/media/image_hand_2.911b3d23.png";